import { ThunkDispatch } from 'redux-thunk'
import {
  RemoteConfigIssue,
  RemoteConfigModel,
  RemoteConfigResponse,
} from 'src/models/remoteConfig.models'
import { RootState } from 'src/redux/createRootReducer'

export const LOAD_FEATURE_FLAGS_SUCCESS =
  'session/featureFlagger/LOAD_FEATURE_FLAGS_SUCCESS'

export type LoadFeatureFlagsSuccessPayload = Partial<RemoteConfigResponse>

export interface LoadFeatureFlagsSuccessAction {
  type: typeof LOAD_FEATURE_FLAGS_SUCCESS
  payload: LoadFeatureFlagsSuccessPayload
}

export type LoadFeatureFlagsActions = LoadFeatureFlagsSuccessAction

const createLoadFeatureFlagsSuccessAction = (
  payload: LoadFeatureFlagsSuccessPayload,
): LoadFeatureFlagsSuccessAction => ({
  type: LOAD_FEATURE_FLAGS_SUCCESS,
  payload,
})

export const loadFeatureFlags = (cookies: Partial<RemoteConfigResponse>) => {
  return (
    dispatch: ThunkDispatch<RootState, void, LoadFeatureFlagsActions>,
  ): void => {
    dispatch(createLoadFeatureFlagsSuccessAction(cookies))
  }
}

export const UPDATE_FEATURE_FLAG_SUCCESS =
  'session/featureFlagger/UPDATE_FEATURE_FLAG_SUCCESS'

export type UpdateFeatureFlagSuccessPayload = {
  featureFlag: keyof RemoteConfigResponse
  val: boolean
}

export interface UpdateFeatureFlagSuccessAction {
  type: typeof UPDATE_FEATURE_FLAG_SUCCESS
  payload: UpdateFeatureFlagSuccessPayload
}

export type UpdateFeatureFlagActions = UpdateFeatureFlagSuccessAction

const createUpdateFeatureFlagSuccessAction = (
  payload: UpdateFeatureFlagSuccessPayload,
): UpdateFeatureFlagSuccessAction => ({
  type: UPDATE_FEATURE_FLAG_SUCCESS,
  payload,
})

export const updateFeatureFlag = (
  featureFlag: keyof RemoteConfigResponse,
  val: boolean,
) => {
  return (
    dispatch: ThunkDispatch<RootState, void, UpdateFeatureFlagActions>,
  ): void => {
    dispatch(
      createUpdateFeatureFlagSuccessAction({
        featureFlag,
        val,
      }),
    )
  }
}

export const GET_REMOTE_CONFIG_INIT =
  'session/remoteConfig/GET_REMOTE_CONFIG_INIT'
export const GET_REMOTE_CONFIG_SUCCESS =
  'session/remoteConfig/GET_REMOTE_CONFIG_SUCCESS'

export type GetRemoteConfigSuccessPayload = RemoteConfigModel
export interface GetRemoteConfigInitAction {
  type: typeof GET_REMOTE_CONFIG_INIT
}
export interface GetRemoteConfigSuccessAction {
  type: typeof GET_REMOTE_CONFIG_SUCCESS
  payload: GetRemoteConfigSuccessPayload
}

export type GetRemoteConfigActions =
  | GetRemoteConfigInitAction
  | GetRemoteConfigSuccessAction

const createGetRemoteConfigInitAction = (): GetRemoteConfigInitAction => ({
  type: GET_REMOTE_CONFIG_INIT,
})

export const createGetRemoteConfigSuccessAction = (
  payload: GetRemoteConfigSuccessPayload,
): GetRemoteConfigSuccessAction => ({
  type: GET_REMOTE_CONFIG_SUCCESS,
  payload,
})

export const getFirebaseRemoteConfig = (
  remoteConfig: RemoteConfigModel,
  cookies?: Partial<RemoteConfigResponse>,
  configIssue?: SetRemoteConfigIssuePayload,
) => {
  return (
    dispatch: ThunkDispatch<
      RootState,
      void,
      GetRemoteConfigActions | SetRemoteConfigIssueAction
    >,
  ): void => {
    dispatch(createGetRemoteConfigInitAction())
    dispatch(createGetRemoteConfigSuccessAction(remoteConfig))
    dispatch(loadFeatureFlags(cookies || remoteConfig))
    dispatch(
      createSetRemoteConfigIssueAction(configIssue ?? RemoteConfigIssue.None),
    )
  }
}

export const SET_REMOTE_CONFIG_ISSUE =
  'session/remoteConfig/SET_REMOTE_CONFIG_ISSUE'

export type SetRemoteConfigIssuePayload = RemoteConfigIssue
export interface SetRemoteConfigIssueAction {
  type: typeof SET_REMOTE_CONFIG_ISSUE
  payload: SetRemoteConfigIssuePayload
}

export type SetRemoteConfigIssueActions = SetRemoteConfigIssueAction

export const createSetRemoteConfigIssueAction = (
  payload: SetRemoteConfigIssuePayload,
): SetRemoteConfigIssueAction => ({
  type: SET_REMOTE_CONFIG_ISSUE,
  payload,
})
